// 用户API
import Request from '../base'
export default {
  save (ui) {
    return Request.post('/eberuser/userapi/user/userInfo/save', ui)
  },
  load (body) {
    return Request.post('/eberuser/userapi/user/userInfo/load', body)
  }
}
